/**
 * Folder GUI component - collapsible container for other GUI elements
 */

import { useState } from "react";
import { Collapse, Box, UnstyledButton, Group, Text } from "@mantine/core";
import type { GuiFolderElement } from "../types";
import { GuiContainer } from "./GuiContainer";

interface GuiFolderProps {
  element: GuiFolderElement;
}

export function GuiFolder({ element }: GuiFolderProps) {
  const [opened, setOpened] = useState(element.expand_by_default);

  return (
    <Box
      style={{
        borderRadius: "4px",
        border: "1px solid var(--mantine-color-gray-3)",
        marginBottom: "8px",
        overflow: "hidden",
      }}
    >
      <UnstyledButton
        onClick={() => setOpened((o) => !o)}
        style={{
          width: "100%",
          padding: "8px 12px",
          backgroundColor: "var(--mantine-color-gray-1)",
          borderBottom: opened ? "1px solid var(--mantine-color-gray-3)" : "none",
        }}
      >
        <Group gap="xs">
          <Text size="sm" style={{ transform: opened ? "rotate(90deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>
            ▶
          </Text>
          <Text size="sm" fw={500}>
            {element.label}
          </Text>
        </Group>
      </UnstyledButton>
      <Collapse in={opened}>
        <Box p="xs">
          <GuiContainer containerUuid={element.uuid} />
        </Box>
      </Collapse>
    </Box>
  );
}
